module.exports = __webpack_public_path__ + "static/img/daba.8a5e76f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cases/daba.png
// module id = jTA6
// module chunks = 1